<script>
		import {user, send_data} from "../client.svelte.js";
		import {protoActions, protoSkills} from "../core.js";

		let { skill } = $props()

		let edited = $state(null)
		let includes = $derived((skill.includes ?? "").split(", ").filter(Boolean).map(actName => protoActions[actName] ?? actName))
		let action = $state(null)
		const tierNumeral = {1: "I", 2: "II", 3: "III", 4: "IV", 5: "V"}

		// console.log(`SKILLCARD - skill ${skill.ID}: `, includes)


		function edit_description(e) {
				if (['Natalie', 'Pierre'].includes(user.ID))
						edited = skill.descript
		}

		async function send_description(e) {
				if (edited !== null && edited !== skill.descript) {
						console.log(`SKILLCARD - change description of ${skill.ID}:`)
						const reply = await send_data(`/edit_abils/${skill.ID}`, {table: 'skills', field: 'descript', value: descript, ident: skill.ID}, 'PATCH')
						if (reply.status === 200) {
								protoSkills[skill.ID].descript = descript
								skill.descript = descript
						} else
								console.error(`SKILLCARD - failed to change description of ${skill.ID}: `, reply.status, reply.statusText, reply.data, reply.headers, reply.config)
						edited = null
				}
		}

		function select_action(e) {
				action = (typeof this === 'object') ? this : null
		}

		function check_keystroke(e) {
				if (e.key === 'Enter')
						send_description(e)
				else if (e.key === 'Escape') {
						edited = null
				}
		}
</script>


<!------------------------------- HTML ------------------------------------->

<div class="skill-card">
	<!-- left margin rail (from Design 02) -->
	<div class="left-rail">
		<div class="cat-icon-box">
			<div class="cat-icon"></div>
		</div>
		<div class="cat-label">{skill.category}</div>
	</div>

	<!-- body (centered tome treatment from Design 01) -->
	<div class="content-box" onclick={edit_description} onkeydown={check_keystroke}>
		<div class="inner-box"></div>

		<!-- name -->
		<h1 class="name clickable" onclick={() => action = null}>{skill.name}</h1>

		<div class="divider">
			<div style="width:34px; height:1px; background:#bdbdb7;"></div>
			<div style="width:7px; height:7px; background:#3a3a35; transform:rotate(45deg);"></div>
			<div style="width:34px; height:1px; background:#bdbdb7;"></div>
		</div>

		{#if action}
			<h2 class="action-header">{action.name}</h2>
		{/if}

		<!-- description -->
		<!--{#if edited}-->
		<!--	<textarea bind:value={edited} id='descript' onchange={send_description}>-->
		<!--		{skill.descript}-->
		<!--	</textarea>-->
		<!--{:else}-->
			<p class="descript">
				{(action) ? action.descript : skill.descript}
			</p>
		<!--{/if}-->

		{#if action?.tiers}
			<div class="tiers-box">
        <h3 class="tiers-header">Stufen</h3>
        <div class="tiers-grid">
	        {#each Object.entries(action.tiers) as [index,tier]}
		        <div class="tiers-row">{tierNumeral[index+1]}</div>
            <div class="tiers-row">{tier}</div>
	        {/each}
        </div>
      </div>
		{/if}

		<div style="flex:1;"></div>

		<!-- related -->
		<div class="related-box">
			<div class="related-header">Mögliche Aktionen</div>
			<div class="related-links">
				{#each includes as aspect, index}
					<span class:clickable={typeof aspect === 'object'} onclick={select_action.bind(aspect)}>{aspect.name ?? aspect}</span>
					{#if index < includes.length - 1}
						<span>·</span>
					{/if}
				{/each}
			</div>
		</div>
	</div>

<!--		<div class="descript-box">-->
<!--        <div data-dc-tpl="74" style="font-family: Cinzel, serif; font-size: 30px; font-weight: 600; color: rgb(31, 31, 28); line-height: 1;"><span class="sc-interp">—</span></div>-->
<!--        <div data-dc-tpl="75" style="font-family: &quot;EB Garamond&quot;, serif; font-style: italic; font-size: 15px; color: rgb(111, 111, 105);"><span class="sc-interp"></span></div>-->
<!--      </div>-->
<!--		<input data-dc-tpl="76" type="text" placeholder="Describe your action (optional)" class="scp1" value="" style="z-index: 1; width: 100%; box-sizing: border-box; margin-top: 12px; background: transparent; border-width: medium medium 1px; border-style: none none solid; border-color: currentcolor currentcolor rgb(182, 181, 175); border-image: none; padding: 8px 2px; font-family: &quot;EB Garamond&quot;, serif; font-size: 16.5px; color: rgb(43, 43, 39); text-align: center; outline: none;">-->
<!--		</div>-->
</div>

<!------------------------------- STYLES ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.skill-card
		width: 640px
		min-height: 540px
		user-select: none
		background: #e8e7e3 repeating-linear-gradient(0deg, rgba(0, 0, 0, 0.018) 0 1px, transparent 1px 5px)
		box-shadow: 0 3px 22px rgba(0,0,0,0.20), inset 0 0 90px rgba(60,60,55,0.10)
		display: flex

	.left-rail
		flex: none
		width: 84px
		border-right: 1px solid #bcbcb6
		background: #dedcd7
		display: flex
		flex-direction: column
		align-items: center
		padding: 34px 0
		position: relative

	.cat-icon-box
		width: 44px
		height: 44px
		border: 1px solid #57574f
		border-radius: 50%
		display: flex
		align-items: center
		justify-content: center
		margin-bottom: 14px

	.cat-icon
		width: 15px
		height: 15px
		border: 1.5px solid #2b2b27
		transform: rotate(45deg)

	.cat-label
		font-family: 'Cinzel',serif
		font-size: 11px
		letter-spacing: 0.26em
		color: #56564f
		text-transform: uppercase
		writing-mode: vertical-rl
		transform: rotate(180deg)

	.content-box
		flex: 1
		position: relative
		box-sizing: border-box
		padding: 44px 42px
		display: flex
		flex-direction: column
		align-items: center
		text-align: center

	.innter-box
		position: absolute
		inset: 14px
		border: 1px solid #c8c7c2
		pointer-events: none

	.name
		z-index: 1
		margin: 8px 0 0
		font-family: 'Cinzel',serif
		font-weight: 600
		font-size: 36px
		line-height: 1.04
		color: #1f1f1c
		letter-spacing: 0.01em

	.divider
		display: flex
		align-items: center
		gap: 12px
		margin: 18px 0 16px
		z-index: 1

	.action-header
		/* margin: 0px 0px 16px; */
		font-family: Cinzel, serif
		font-weight: 500
		font-size: 14px
		letter-spacing: 0.28em
		color: rgb(86, 86, 79)
		text-transform: uppercase

	.descript
		z-index: 1
		margin: 0
		font-family: 'EB Garamond',serif
		font-size: 17.5px
		line-height: 1.6
		color: #33332e
		max-width: 560px
		text-wrap: pretty

	#descript
		width: 100%
		height: 100%

	.tiers-box
		width: 100%
		margin-top: 22px
		text-align: left

		.tiers-header
			font-family: Cinzel serif
			font-size: 10.5px
			letter-spacing: 0.3em
			color: rgb(111, 111, 105)
			text-transform: uppercase
			margin-bottom: 8px
			text-align: center

		.tiers-grid
			display: grid
			grid-template-columns: auto 1fr
			gap: 0 16px
			border-top: 1px solid rgb(200, 199, 194)
			font-family: "EB Garamond", serif
			font-size: 15.5px
			color: rgb(51, 51, 46)

		.tiers-row
			font-family: Cinzel, serif
			font-size: 11px
			letter-spacing: 0.12em
			color: rgb(86, 86, 79)
			padding: 7px 0px 6px
			border-bottom: 1px solid rgb(216, 215, 210)


	.related-box
		z-index: 1
		width: 100%
		margin-top: 24px

	.related-header
		font-family: 'Cinzel',serif
		font-size: 10.5px
		letter-spacing: 0.3em
		color: #6f6f69
		text-transform: uppercase
		margin-bottom: 8px

	.related-links
		display: flex
		justify-content: center
		gap: 8px 22px
		flex-wrap: wrap
		font-family: 'EB Garamond',serif
		font-style: italic
		font-size: 16px
		color: #3d3d38

		.clickable
			text-decoration: underline

	.descript-box
		display: flex
		align-items: baseline
		justify-content: center
		gap: 10px
		min-height: 38px
</style>